import { GameState } from "./GameState";



const Reset = ({ gameState, onReset }) => {

    if (gameState !== GameState.inProgress) {
        return;
    }
    return (
        <>
            <button className="reset_button" onClick={onReset}>Reset</button>
        </>
    )
};



export default Reset;